import { useMutation, useQueryClient } from '@tanstack/react-query';

import luxPlusPricingConfigService, {
  CreateLuxPlusPricingConfigBody,
} from '~/services/cruises/LuxPlusPricingConfigService';

import { luxPlusPricingConfigQueryKeys } from './luxPlusPricingConfigQueryKeys';

export function useCreateLuxPlusPricingConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateLuxPlusPricingConfigBody) => luxPlusPricingConfigService.create(body),
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: luxPlusPricingConfigQueryKeys.list(variables.vendorId) });
    },
  });
}

export function useUpdateLuxPlusPricingConfigEnabled(vendorId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, enabled }: { id: string; enabled: boolean }) =>
      luxPlusPricingConfigService.updateEnabled(id, enabled),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: luxPlusPricingConfigQueryKeys.list(vendorId) });
    },
  });
}

export function useDeleteLuxPlusPricingConfig(vendorId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => luxPlusPricingConfigService.deleteById(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: luxPlusPricingConfigQueryKeys.list(vendorId) });
    },
  });
}
